import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { firstValueFrom, Observable } from 'rxjs';
import { AuthService } from '../services/auth.service';
import { TokenService } from '../services/token.service';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {

  constructor(private router: Router,
    private auth:AuthService,
    private token:TokenService) { }

  async canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot) {
    const tokenSet:boolean = this.token.get() != null;
    const loggedIn:boolean = tokenSet && await firstValueFrom(this.auth.refreshToken());

    const signatory_uuid = route.queryParamMap.get('signatory_uuid');
    const signature_uuid = route.params['signature_uuid'];

    if(signatory_uuid != null) {
      return this.redirectToSignature(signatory_uuid, signature_uuid);
    }

    if(!loggedIn) {
      return this.logout();
    }

    return true;
  }

  private logout() {
    this.auth.logout();
    this.router.navigate(['/home']);
    return false;
  }

  private redirectToSignature(signatory_uuid:string, signature_uuid:string) {
    this.auth.logout();
    this.router.navigate(['/signatures', 'auth', 'request-otp'], { queryParams: { signatory_uuid: signatory_uuid, signature_uuid: signature_uuid } });
    return false;
  }

}
